import * as THREE from "three"

export function createMissingTexture(size = 16): THREE.CanvasTexture {
  const canvas = document.createElement("canvas")
  canvas.width = size
  canvas.height = size
  const context = canvas.getContext("2d")

  if (!context) {
    // Fallback if canvas context cannot be created
    console.error("Failed to get 2D context for missing texture")
    // Create a simple magenta texture as a last resort if canvas fails
    const data = new Uint8Array(3 * size * size)
    for (let i = 0; i < size * size; i++) {
      data[i * 3] = 255 // R
      data[i * 3 + 1] = 0 // G
      data[i * 3 + 2] = 255 // B
    }
    const fallbackTexture = new THREE.DataTexture(data, size, size, THREE.RGBFormat)
    fallbackTexture.needsUpdate = true
    return fallbackTexture as unknown as THREE.CanvasTexture // Cast for consistency, though it's DataTexture
  }

  const purple = "#F800F8" // Minecraft purple
  const black = "#000000"
  const halfSize = Math.floor(size / 2) // Use Math.floor for odd sizes
  const otherHalf = size - halfSize

  // Top-left (purple)
  context.fillStyle = purple
  context.fillRect(0, 0, halfSize, halfSize)
  // Bottom-right (purple)
  context.fillRect(halfSize, halfSize, otherHalf, otherHalf)

  // Top-right (black)
  context.fillStyle = black
  context.fillRect(halfSize, 0, otherHalf, halfSize)
  // Bottom-left (black)
  context.fillRect(0, halfSize, halfSize, otherHalf)

  const texture = new THREE.CanvasTexture(canvas)
  texture.magFilter = THREE.NearestFilter
  texture.minFilter = THREE.NearestFilter
  texture.needsUpdate = true // Important for canvas textures
  return texture
}
